<!-- 卡方检验 -->
<template>
    <div class="excavate-check">
        <analysisOption @option_click='option_click'> </analysisOption>
        <div class="excavate-table">
            <el-table
                :data='checkList'
                :header-cell-style="{background:'#a7754f',color:'#fff'}"
                size='mini'
                border
                default-expand-all>
                <el-table-column
                    width="240px"
                    label="类型"
                    prop="typeName"
                >
                </el-table-column>
                <el-table-column
                    prop="description"
                    label="说明">
                </el-table-column>
            </el-table>
        </div>
        <div class="btn-center">
            <el-button  type="primary" size="small" @click='check_click'>卡方检验</el-button>
        </div>
        <!-- 分析内容 -->
        <analysisInfo ref='analysis_info'   v-if="isShowInfo" :beforeValue='beforeValue' :afterValue='afterValue' :analysisType='"check"' ></analysisInfo>

    </div>
</template>

<script>
import analysisOption from "./comps/analysis_option.vue"
import excavateData from './comps/excavateData.js'
import analysisInfo from './comps/analysis_info.vue'
export default {
    components: {
        analysisOption,
        analysisInfo,
    },
    data () {
        return { 
            isShowInfo:false,
            checkList:excavateData.checkList,
            radioOption:excavateData.radioOption,
            // isShowReport:false,
            // reportName:'',
            // pNum:'',
            // frequencyNum:'',
            tableList:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            beforeRadio:'clinicalFeature',
            beforeValue:'临床表现',
            afterRadio:'clinicalFeature',
            afterValue:'临床表现',
        }
    },
    methods: {
        // 获取选择后的值
        option_click(params){
            if(params.type=='before'){
                this.beforeRadio = params.val;
                this.beforeValue=params.valName
            }else if(params.type=='after'){
                this.afterRadio = params.val;
                this.afterValue=params.valName
            }
        },
        check_click(req){
            this.isShowInfo = true;
            this.$nextTick(()=>{
                this.$refs.analysis_info.filtrate_result()
            }) 
        }, 
    }
}
</script>

<style>

</style>